import { config } from "../config";

export function frameParentOrigin(): string {
  if (window.parent === window) return "";
  try {
    const origin = new URL(document.referrer).origin;
    if (origin === location.origin) return origin;
    if (location.origin === config.videoSiteOrigin && config.embedParentOrigins.includes(origin)) return origin;
  } catch { /* Untrusted or missing referrer cannot receive account messages. */ }
  return "";
}

export function requestEmbedTicket(): Promise<string> {
  const origin = frameParentOrigin();
  if (!origin || origin === location.origin) return Promise.reject(new Error("无法连接用户网页，请重新打开观看页面。"));
  const requestId = crypto.randomUUID();
  return new Promise((resolve, reject) => {
    const finish = () => { clearTimeout(timer); removeEventListener("message", receive); };
    const receive = (event: MessageEvent) => {
      if (event.source !== window.parent || event.origin !== origin || event.data?.type !== "yestv:embed-ticket" || event.data.requestId !== requestId) return;
      finish();
      if (typeof event.data.ticket === "string" && /^[0-9a-f]{64}$/.test(event.data.ticket)) resolve(event.data.ticket);
      else reject(new Error("观看连接已失效，请重新打开用户网页。"));
    };
    const timer = setTimeout(() => { finish(); reject(new Error("用户网页连接超时，请重试。")); }, 10000);
    addEventListener("message", receive);
    window.parent.postMessage({ type: "yestv:embed-account", requestId }, origin);
  });
}
